import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-error-publish-dialog',
  templateUrl: './error-publish-dialog.component.html',
  styleUrls: ['./error-publish-dialog.component.scss'],
})
export class ErrorPublishDialogComponent {
  error: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: ErrorPublishDialogModel,
    private translate: TranslateService,
  ) {
    this.error = data.error.message;

    if (this.translate.currentLang === 'it' && !!data.error.messageIt) {
      this.error = data.error.messageIt;
    }
  }
}

export interface ErrorPublishDialogModel {
  error: {
    message: string;
    messageIt?: string;
  };
}
